module.exports = __webpack_public_path__ + "img/login_img.447f4137.png";